import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UnassignSurveyRPC } from "./unassignSurveyRPC";

export class UnassignSurveyRPCClientImpl extends UnassignSurveyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UnassignSurveyRPC.Request): Promise<LeoRPCResult<UnassignSurveyRPC.Response, UnassignSurveyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/UnassignSurvey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UnassignSurveyRPC.ResponseDTO,
      UnassignSurveyRPC.Errors.ErrorsDTO,
      UnassignSurveyRPC.Response,
      UnassignSurveyRPC.Errors.Errors
    >(
      response,
      "respondent/UnassignSurvey",
      UnassignSurveyRPC.Response.fromDTO,
      UnassignSurveyRPC.Errors.fromDTO
    );
  }
}
